import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImageSuccessSvg';

export const ResponsesImageSuccess = createResponsesImage({
  name: 'ResponsesImageSuccess',
  component,
});
